var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings.canEnterCode)?_c('f7-list-input',{attrs:{"label":_vm.$t('modules.referral.code.promocode'),"maxlength":"16"},on:{"input":function($event){return _vm.onInput($event.target.value)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }